import { render, staticRenderFns } from "./TipoComprobante.vue?vue&type=template&id=04aa24bb"
import script from "./TipoComprobante.vue?vue&type=script&lang=ts"
export * from "./TipoComprobante.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports